import { render, staticRenderFns } from "./NoEncontrado.vue?vue&type=template&id=1dc535ec"
import script from "./NoEncontrado.vue?vue&type=script&lang=js"
export * from "./NoEncontrado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports